<template>
  <nav
    v-if="totalPage > 1"
    class="pagination is-centered"
    role="navigation"
    aria-label="pagination"
  >
    <a
      v-show="currentPageNumber > totalPageInView"
      class="pagination-previous"
      aria-label="Previous"
      @click="{ updatePage(currentPageNumber - totalPageInView); additionalAction(); }"
    >
      <ArrowIcon />  {{ $t("pagination.previous", {count: totalPageInView, label: 'Pages' }) }}
    </a>
    <a
      v-show="currentPageNumber < totalPage - totalPageInView"
      class="pagination-next"
      @click="{ updatePage(currentPageNumber + totalPageInView); additionalAction(); }"
    >
      {{ $t("pagination.next", {count: totalPageInView, label: 'Pages' }) }}
      <ArrowIcon />
    </a>
    <ul class="pagination-list">
      <li
        v-for="index in Math.min(totalPage, totalPageInView)"
        :key="index"
      >
        <a
          v-if="startPageInView*totalPageInView + index <= totalPage"
          class="pagination-link"
          :aria-label="'Goto page ' + index"

          :class="{'is-current': startPageInView*totalPageInView + index === currentPageNumber}"
          @click="{ updatePage(startPageInView*totalPageInView + index); additionalAction(); }"
        >
          {{ startPageInView*totalPageInView + index }}
        </a>
      </li>
    </ul>
  </nav>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import ArrowIcon from '../assets/navArrow.svg';

const props = defineProps({
  currentPageNumber: { type: Number, default: 1 },
  totalPage: { type: Number, required: true },
  totalPageInView: { type: Number, default: 5 },
  updatePage: { type: Function, default: null },
  additionalAction: { type: Function, default: null }
});

const startPageInView = computed(() => Math.floor((props.currentPageNumber - 1) / props.totalPageInView));

</script>
<style scoped lang="scss">
.pagination>li {
    display: inline;
    font-family: Montserrat,sans-serif;
  > a:hover, &.active > a {
    font-weight: 600;
    opacity: 1;
  }
  &.pageNumber a {
    opacity: 1;
    color: #333;
  }
  > a {
    opacity:0.61;
    margin: 0 2px;
    color: #737373;
    padding: 4px 6px;
    position: relative;
    line-height: 1.42857143;
    text-decoration: none;
    margin-left: -1px;
    }
}
a {
  cursor: pointer;
}
.pagination-previous, .pagination-next {
  color: #757575;
}
</style>
